/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {executeCreatePin} from '../api'

export const useMutationExecuteCreatePin = createReactQueryMutationHook('executeCreatePin', executeCreatePin)
